import React from 'react';
import {
    Form, Input, Label, FormGroup, Card, Button, CardBody,
    Modal, ModalHeader, ModalBody, ModalFooter, Progress, FormText,
} from 'reactstrap';
import { appHelpers, store } from '../../_helpers';
import SecurityChargeReportTable from './report-table';
import moment from "moment/moment";

import NotificationSystem from 'react-notification-system';
import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";
import { commonService } from "../../_services";

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
//Icons
import SecurityChargeFilterPanel from "./filter-panel";
// import OutstandingAirlinePanel from "./outstanding-panel";
import ReportIcon from 'react-icons/lib/md/bubble-chart';


const ViewContent = ({ children }) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class SecurityChargeViewContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            airline: [],
            reports: [],
            modal: false,
            modalClass: '',
            //Security charge form
            passedMainSelection: false,
            AirlineId: '',
            SourceAirportId: -1,
            SourceAirlineId: -1,
            ROE: '',
            OutstandingAirline: '',
            OutstandingAirlineId: '',
            OutstandingAirport: '',
            OutstandingAirportId: '',
            OutstandingROE: '',
            OutstandingFlightStartDate: new Date(),
            OutstandingFlightEndDate: new Date(),
            FlightStartDate: new Date(),
            FlightEndDate: new Date(),
            showOutstandingAirlines: false,
            outstandingAirlines: [],
            isVGGUser: false,

            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],  //Errors generated within the component form
            outstandingErrorMessages: [],  //Errors generated within the component form
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            positionFromBottom: 0,
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const reduxState = store.getState();
        let { airlinesCarriers, desAirports, authentication } = reduxState;
        if (airlinesCarriers) {
            this.setState({ airlines: airlinesCarriers.Results })
        } else {
            this.fetchAirlines();
        }
        if (desAirports) {
            this.setState({ airports: desAirports.Results })
        } else {
            this.fetchAirports();
        }
        if (authentication.user !== undefined) {
            const { user } = authentication
            if (user.AviRole === appConstants.ROLES.VGG_SUPERADMIN || user.AviRole === appConstants.ROLES.VGG_USER) {
                this.setState({ isVGGUser: true })
            } else {
                this.setState({ isVGGUser: false })
            }
        }

        window.addEventListener('scroll', this.onScroll, false);
        this.onScroll();
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll, false);
    }

    componentWillReceiveProps = function (nextProps) {
        const { alert } = nextProps;
        const { modal } = nextProps;

        if (alert) {
            if (alert.type === alertConstants.SUCCESS) {
                // this.setState({error: false, success: alert.message})
                this.setState({ error: false, success: 'Operation successful' });
                this.resetForm();
            }
            else if (alert.type === alertConstants.CLEAR) {
                this.setState({ success: false, error: false })

            } else {
                this.setState({ success: false, error: alert.message })
            }
        }
        if (modal) {
            if (modal.type === appConstants.OPEN_MODAL) {
                this.setState({
                    modal: true,
                    modalClass: modal.modalClass
                });
            } else if (modal.type === appConstants.CLOSE_MODAL) {
                this.setState({
                    modal: false,
                    modalClass: modal.modalClass
                });
                this.resetForm();
            }
        }

    };

    handleChange = (targetValue, attribute) => {
        let currState = this.state;
        currState[attribute] = targetValue;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({ componentErrorMessages: errorMessages });
    };

    /* Outstanding has not been implemented in the backend yet*/
    // handleOutstandingChange = (targetValue, attribute) => {
    //     let currState = this.state;
    //     currState[attribute] = targetValue;
    //     let errorMessages = this.state.outstandingErrorMessages;
    //     errorMessages[attribute] = false;
    //     this.setState(currState);
    //     this.setState({ outstandingErrorMessages: errorMessages });
    // };

    handleSelectChange = (payload, attribute) => {
        // console.log({payload, attribute})
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        currState[attribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
        if (!payload) {
            currState[attribute] = '';
        } else {
            if (attribute === 'OutstandingAirportId') {
                currState[attribute] = payload.Id;
                currState['OutstandingAirport'] = payload.Name;
            }
            else if (attribute === 'OutstandingAirlineId') {
                currState[attribute] = payload.Id;
                currState['OutstandingAirline'] = payload.Name;
            }
            else {
                currState[attribute] = payload.Id;
            }
        }
        this.setState(currState);
        this.setState({ componentErrorMessages: errorMessages });

    };
    /* Outstanding has not been implemented in the backend yet*/
    // handleOutstandingSelectChange = (payload, attribute) => {
    //     let currState = this.state;
    //     let errorMessages = this.state.outstandingErrorMessages;
    //     errorMessages[attribute] = false;
    //     currState[attribute] = (payload) ? payload.Id : '';
    //
    //     if (payload) {
    //         if (attribute === 'OutstandingAirportId') {
    //             currState['OutstandingAirport'] = payload.Name;
    //         }
    //         else if (attribute === 'OutstandingAirlineId') {
    //             currState['OutstandingAirline'] = payload.Name;
    //         }
    //     }
    //     this.setState(currState);
    //     this.setState({ outstandingErrorMessages: errorMessages });
    //
    // };

    /* Outstanding has not been implemented in the backend yet*/
    // toggleOutstandingAirlines = (event) => {
    //     event.preventDefault();
    //     const showOutstandingAirlines = this.state.showOutstandingAirlines;
    //     this.setState({ showOutstandingAirlines: !showOutstandingAirlines });
    // };

    onScroll = () => {
        const positionOffset = document.body.offsetHeight - window.innerHeight - window.scrollY + 50;
        this.setState({ positionFromBottom: positionOffset });
    };

    validateInput = () => {
        let _errs_ = [];        
        let formValid = true;
        if (isNaN(parseInt(this.state.ROE, 10))) {
            _errs_['ROE'] = 'Please enter a valid ROE';
            formValid = false;
        }
        
        if (this.state.FlightStartDate === '') {
            _errs_['FlightStartDate'] = 'Please select flight date';
            formValid = false;
        }
        if (this.state.SourceAirlineId === -1 || this.state.SourceAirlineId === "") {
            _errs_['SourceAirlineId'] = 'Please select an Airline';
            formValid = false;
        }

        if (this.state.FlightEndDate === '') {
            _errs_['FlightEndDate'] = 'Please select flight date';
            formValid = false;
        }
        this.setState({ componentErrorMessages: _errs_, passedMainSelection: formValid });
        return formValid;
    };

    /* Outstanding has not been implemented in the backend yet*/
    // validateOutstandingInput = () => {
    //     let _errs_ = [];
    //     let formValid = true;
    //     if (this.state.OutstandingAirlineId === '') {
    //         _errs_['OutstandingAirlineId'] = 'Please select airline';
    //         formValid = false;
    //     }
    //
    //     if (isNaN(parseInt(this.state.OutstandingROE, 10))) {
    //         _errs_['OutstandingROE'] = 'Please enter ROE';
    //         formValid = false;
    //     }
    //
    //     if (this.state.OutstandingFlightStartDate === '') {
    //         _errs_['OutstandingFlightStartDate'] = 'Please select flight start date';
    //         formValid = false;
    //     }
    //     if (this.state.OutstandingFlightEndDate === '') {
    //         _errs_['OutstandingFlightEndDate'] = 'Please select flight end date';
    //         formValid = false;
    //     }
    //     this.setState({ outstandingErrorMessages: _errs_ });
    //     return formValid;
    // };

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    resetForm() {
        this.setState({ componentError: false, componentErrorMessages: [], AirlineId: '', ROE: '', FlightStartDate: '', FlightEndDate: '' });
        this.resetError();
    }

    resetError() {
        this.props.dispatch(modalActions.clear());
        this.props.dispatch(alertActions.clear());
    }

    search = (pageNumber = 0) => {
        let { SourceAirportId, SourceAirlineId, ROE, FlightStartDate, FlightEndDate, pageSize } = this.state;
        const { dispatch } = this.props;
        dispatch(apiActions.startRequest());

        if (this.validateInput()) {
            const payload = {
                StartDate: moment(FlightStartDate).startOf('month').format("YYYY-MM-DD"),
                EndDate: moment(FlightEndDate).endOf('month').format("YYYY-MM-DD"),
                AirportId: SourceAirportId,
                AirlineId: SourceAirlineId,
                ExchangeRate: ROE,
                Page: (pageNumber === 1 || pageNumber === 0) ? 1 : (pageSize * (pageNumber - 1) + 1),
                PageSize: pageSize
            }
            // const mainSelection = [
            //     {
            //         SearchModel: {
            //             FlightStartDate: moment(FlightStartDate).startOf('month').format("YYYY-MM-DD"),
            //             FlightEndDate: moment(FlightEndDate).endOf('month').format("YYYY-MM-DD"),
            //             AirportId: SourceAirportId,
            //             // AirlineId: SourceAirlineId,
            //         },
            //         MainSelection: true, ROE: ROE
            //     }
            // ];
            // if (addedOutstanding) {
            //     outstandingAirlines = [...outstandingAirlines, {
            //         OutstandingFlightStartDate: moment(addedOutstanding.OutstandingFlightStartDate).format("YYYY-MM-DD"),
            //         OutstandingFlightEndDate: moment(addedOutstanding.OutstandingFlightEndDate).format("YYYY-MM-DD"),
            //         OutstandingAirportId: addedOutstanding.OutstandingAirportId,
            //         OutstandingAirport: addedOutstanding.OutstandingAirport,
            //         OutstandingAirline: addedOutstanding.OutstandingAirline,
            //         OutstandingAirlineId: addedOutstanding.OutstandingAirlineId,
            //         OutstandingROE: addedOutstanding.OutstandingROE,
            //     }];
            // }
            //
            // // Add Outstanding to Main selection
            // outstandingAirlines.forEach(item => {
            //     mainSelection.push({
            //         SearchModel: {
            //             FlightStartDate: moment(item.OutstandingFlightStartDate).format("YYYY-MM-DD"),
            //             FlightEndDate: moment(item.OutstandingFlightEndDate).format("YYYY-MM-DD"),
            //             AirlineId: item.OutstandingAirlineId
            //         },
            //         MainSelection: false,
            //         ROE: item.OutstandingROE
            //     })
            // });
            commonService.getSecurityChargeReport(payload)
                .then((res) => {
                    // console.log({res})
                    if (res.status === appConstants.SUCCESS_RESPONSE) {
                        this.setState({ reports: res.response.SecurityCharges, totalCount: res.response.TotalCount, currentPage: pageNumber === 0 ? 1 : pageNumber});
                        // if (addedOutstanding) {
                        //     this.resetOutstandingAirlines();
                        //     this.setState({ outstandingAirlines: outstandingAirlines })
                        // }
                        dispatch(apiActions.endRequest());
                        this.onScroll();
                    }
                    else if (res.status === appConstants.ERROR_RESPONSE) {
                        this.notify(res.response, appConstants.NOTIFY_ERROR);
                        dispatch(apiActions.endRequest());
                        this.onScroll();
                    }
                });
        } else {
            dispatch(apiActions.endRequest());
        }

    };

    fetchAirlines = () => {
        this.setState({ contentError: false });
        const { dispatch, airlinesCarriers } = this.props;
        if (!airlinesCarriers) {
            dispatch(apiActions.startFullPageRequest());
        } else {
            dispatch(apiActions.startRequest());
        }

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                let { airlinesCarriers } = this.props;
                this.setState({ airlines: airlinesCarriers.Results });
                dispatch(apiActions.endRequest());
            }).catch(error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({ contentError: errorMessage });
                dispatch(apiActions.endRequest());
            });
    };

    fetchAirports = () => {
        this.setState({ contentError: false });
        const { dispatch, airports } = this.props;
        if (!airports) {
            dispatch(apiActions.startFullPageRequest());
        } else {
            dispatch(apiActions.startRequest());
        }

        dispatch(commonActions.getDesAirports())
            .then(() => {
                let { desAirports } = this.props;
                this.setState({ airports: desAirports.Results });
                dispatch(apiActions.endRequest());
            }).catch(error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({ contentError: errorMessage });
                dispatch(apiActions.endRequest());
            });
    };

    toggle = (e, modalClass) => {
        if (this.state.modal) {
            this.resetForm();
            this.props.dispatch(modalActions.close({ 'modalClass': modalClass }));
        } else {
            this.props.dispatch(modalActions.open({ 'modalClass': modalClass }));
        }
    };

    toggleCheckbox = (attribute) => {
        let currState = this.state;
        currState[attribute] = !currState[attribute];
        this.setState(currState);
    };

    /* Outstanding has not been implemented in the backend yet*/
    // addOutstandingAirline = () => {
    //     if (this.validateOutstandingInput()) {
    //         let { OutstandingROE, OutstandingFlightStartDate, OutstandingFlightEndDate, OutstandingAirportId, OutstandingAirport, OutstandingAirline, OutstandingAirlineId } = this.state;
    //         const newOutstanding = {
    //             OutstandingFlightStartDate: OutstandingFlightStartDate,
    //             OutstandingFlightEndDate: OutstandingFlightEndDate,
    //             OutstandingAirportId: OutstandingAirportId,
    //             OutstandingAirport: OutstandingAirport,
    //             OutstandingAirline: OutstandingAirline,
    //             OutstandingAirlineId: OutstandingAirlineId,
    //             OutstandingROE: OutstandingROE,
    //         };
    //
    //         this.search(newOutstanding);
    //     }
    //
    // };

    // removeOutstandingAirline = (index) => {
    //     const oa = [...this.state.outstandingAirlines];
    //     oa.splice(index, 1);
    //     this.setState({ outstandingAirlines: oa });
    //     this.search();
    // };
    //
    // resetOutstandingAirlines = () => {
    //     this.setState({ OutstandingROE: '', OutstandingAirportId: '', OutstandingAirlineId: '' });
    // };

    handleReportDownload = () => {
        const { dispatch } = this.props;
        const { SourceAirportId, ROE, FlightStartDate, FlightEndDate, SourceAirlineId } = this.state;
        dispatch(apiActions.startRequest());
        const payload = {
            StartDate:  moment(FlightStartDate).startOf('month').format("YYYY-MM-DD"),
            EndDate: moment(FlightEndDate).endOf('month').format("YYYY-MM-DD"),
            AirportId: SourceAirportId,
            AirlineId: SourceAirlineId,
            ExchangeRate: ROE
        }
        // const mainSelection = [
        //     {
        //         SearchModel: {
        //             FlightStartDate: moment(FlightStartDate).startOf('month').format("YYYY-MM-DD"),
        //             FlightEndDate: moment(FlightEndDate).endOf('month').format("YYYY-MM-DD"),
        //             SourceAirportId: SourceAirportId
        //         },
        //         MainSelection: true, ROE: ROE
        //     }
        // ];
        // outstandingAirlines.forEach(item => {
        //     mainSelection.push({
        //         SearchModel: {
        //             FlightStartDate: moment(item.OutstandingFlightStartDate).format("YYYY-MM-DD"),
        //             FlightEndDate: moment(item.OutstandingFlightEndDate).format("YYYY-MM-DD"),
        //             AirlineId: item.OutstandingAirlineId
        //         },
        //         MainSelection: false,
        //         ROE: item.OutstandingROE
        //     })
        // });

        commonService.downloadSecurityChargeReport(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let response = res.response;
                    window.open(response.File, '_blank');
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });

    };


    renderPageResponse() {
        if (this.state.error) {
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if (this.state.componentError) {
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if (this.state.success) {
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    render() {
        let modalResponse = this.renderPageResponse();
        const { requesting } = this.props;
        const { pageRequesting } = this.props;

        const { contentError, passedMainSelection,
            airlines, airports, SourceAirportId, SourceAirlineId, ROE, FlightStartDate,
            componentErrorMessages, reports, positionFromBottom, isVGGUser,
            totalCount, pageSize, currentPage} = this.state;
        
        /* Commented out outstanding airlines data in state */
        // const { contentError, outstandingAirlines, passedMainSelection, 
        //     airlines, airports, SourceAirportId, SourceAirlineId, ROE, FlightStartDate,
        //     showOutstandingAirlines, componentErrorMessages, reports, 
        //     OutstandingAirlineId, OutstandingAirportId, OutstandingROE, 
        //     OutstandingFlightStartDate, OutstandingFlightEndDate, 
        //     outstandingErrorMessages, positionFromBottom, isVGGUser } = this.state;
   
        const reportsLength = totalCount;
        return (
            <div className="view">
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        {((pageRequesting || requesting) && !pageRequesting) && <Progress animated striped color="success" value={100} className="mb-2" />}

                        {/*Display loader when component content is dependent on Data from API*/}
                        {(!contentError && pageRequesting) &&
                            <PageLoading />
                        }

                        {/*Display error when component fail to get Data from API*/}
                        {contentError &&
                            <PageError error={this.state.contentError} />
                        }

                        {/*Display component content when Data is gotten from API*/}
                        {(!contentError && !pageRequesting) &&
                            <CardBody className="table-responsive">
                                <h6 className="mb-2 text-uppercase">
                                    Search Panel
                                     {(!pageRequesting && reportsLength === 1) &&
                                        <FormText color="muted">
                                            <ReportIcon size="18" color="#43a8df" />{appHelpers.numberWithCommasOnly(reportsLength)} record
                                         </FormText>
                                    }
                                    {(!pageRequesting && reportsLength > 1) &&
                                    <FormText color="muted">
                                        <ReportIcon size="18" color="#43a8df" />{appHelpers.numberWithCommasOnly(reportsLength)} records
                                    </FormText>
                                    }
                                </h6>
                                <SecurityChargeFilterPanel
                                handleReportDownload={this.handleReportDownload} 
                                reportsLength={reportsLength} 
                                // showOutstandingAirlines={showOutstandingAirlines}
                                requesting={requesting} 
                                passedMainSelection={passedMainSelection} 
                                // removeOutstandingAirline={this.removeOutstandingAirline}
                                // outstandingAirlines={outstandingAirlines}
                                // toggleOutstandingAirlines={this.toggleOutstandingAirlines}
                                componentErrorMessages={componentErrorMessages} 
                                handleChange={this.handleChange} 
                                handleSelectChange={this.handleSelectChange} 
                                airports={airports}
                                airlines={airlines}
                                onSearch={() => this.search()}
                                SourceAirportId={SourceAirportId} 
                                SourceAirlineId={SourceAirlineId}
                                ROE={ROE}
                                FlightStartDate={FlightStartDate}
                                isVGGUser={isVGGUser} />

                                {/*{*/}
                                    {/*showOutstandingAirlines &&*/}
                                    {/*<OutstandingAirlinePanel handleSelectChange={this.handleOutstandingSelectChange} handleAddOutstandingAirline={this.addOutstandingAirline} outstandingAirlines={outstandingAirlines} outstandingErrorMessages={outstandingErrorMessages} handleChange={this.handleOutstandingChange} airports={airports} airlines={airlines} onSearch={this.search} OutstandingAirportId={OutstandingAirportId} OutstandingAirlineId={OutstandingAirlineId} OutstandingROE={OutstandingROE} OutstandingFlightStartDate={OutstandingFlightStartDate} OutstandingFlightEndDate={OutstandingFlightEndDate} />*/}
                                {/*}*/}

                                {(!pageRequesting && reportsLength > 0) &&
                                    <SecurityChargeReportTable
                                        handleReportDownload={this.handleReportDownload}
                                        positionFromBottom={positionFromBottom}
                                        data={reports} totalCount={totalCount}
                                        pageSize={pageSize}
                                        fetchMore={this.search}
                                        currentPage={currentPage}
                                    />
                                }

                                {(!pageRequesting && reportsLength === 0) &&
                                    <PageEmptyContent message='No record match your search!' />
                                }

                                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.state.modalClass}>
                                    <ModalHeader toggle={this.toggle}>Airports</ModalHeader>
                                    <Form>
                                        <ModalBody>

                                            {modalResponse}

                                            <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.Name ? 'has-danger' : '')}>
                                                <Label>Airport Name</Label>
                                                <Input type="text" placeholder="" value={this.state.Name} onChange={(event) => this.handleChange(event, 'Name')} />
                                                {componentErrorMessages.Name && <FormText color="danger"> {componentErrorMessages.Name}</FormText>}
                                            </FormGroup>
                                            <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.Code ? 'has-danger' : '')}>
                                                <Label>Airport Code</Label>
                                                <Input type="text" placeholder="" value={this.state.Code} onChange={(event) => this.handleChange(event, 'Code')} />
                                                {componentErrorMessages.Code && <FormText color="danger"> {componentErrorMessages.Code}</FormText>}
                                            </FormGroup>
                                            <FormGroup className={"mb-4 " + (this.state.componentErrorMessages.IsLocal ? 'has-danger' : '')}>
                                                <input type="checkbox" className="checkbox-control" name="disabled" checked={this.state.IsLocal} onChange={() => this.toggleCheckbox('IsLocal')} />
                                                <span className="checkbox-label">&nbsp;Is local?</span>
                                            </FormGroup>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button className="btn-avi-primary" disabled={requesting} > Proceed </Button>{' '}
                                            <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                                        </ModalFooter>
                                    </Form>
                                    {requesting && <div className={'loading-dot active'}></div>}
                                </Modal>
                            </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem" />
                    </Card>
                </ViewContent>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { requesting, pageRequesting } = state.api;
    const { alert, modal, airlinesCarriers, desAirports } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        modal,
        alert,
        airlinesCarriers,
        desAirports,
    };
}
export default connect(mapStateToProps)(SecurityChargeViewContent);



// WEBPACK FOOTER //
// ./src/views/security-charge-report/view-content.js